var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.667 14.1667C16.667 11.5661 14.5589 9.45801 11.9583 9.45801L4.26699 9.45801C3.80675 9.45801 3.43366 9.08492 3.43366 8.62468C3.43366 8.16444 3.80675 7.79134 4.26699 7.79134L11.9583 7.79134C15.4793 7.79134 18.3337 10.6457 18.3337 14.1667C18.3337 14.6269 17.9606 15 17.5003 15C17.0401 15 16.667 14.6269 16.667 14.1667Z",
    fill: "#DF853B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71426 5.24408C7.03969 5.56951 7.03969 6.09715 6.71426 6.42259L4.51184 8.625L6.71426 10.8274C7.03969 11.1528 7.03969 11.6805 6.71426 12.0059C6.38882 12.3314 5.86118 12.3314 5.53574 12.0059L2.74408 9.21426C2.41864 8.88882 2.41864 8.36118 2.74408 8.03574L5.53574 5.24408C5.86118 4.91864 6.38882 4.91864 6.71426 5.24408Z",
    fill: "#DF853B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.2499cf27e2c223eabb24469cd932dfbc.svg";
export { ForwardRef as ReactComponent };